import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
import { jsx as _jsx } from "react/jsx-runtime";
var FlagIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/_jsx(BaseSvg, _objectSpread(_objectSpread({}, otherProps), {}, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden,
    children: /*#__PURE__*/_jsx("path", {
      d: "M14.95,5.538c-6.221,9.569 -4.091,-0.183 -9.35,4.483l1.195,4.979l-1.344,0l-2.441,-10.163l1.232,-0.469c5.895,-4.563 2.816,4.106 10.416,0.885c0.242,-0.103 0.436,0.064 0.292,0.285Z"
    })
  }));
});
FlagIcon.displayName = 'FlagIcon';
export default FlagIcon;